import Component from '../abstracts/Component';

export default class CartComponent extends Component {

  get SELECTORS() {
    return {
      cart: '[data-cart-wrapper]',
      qtyBtn: '[data-cart-add-remove]',
      more: '[data-cart-more]',
      less: '[data-cart-less]',
      qty: '[data-cart-qty]',
      shippingRadios: '[data-shipping-method] input[type=radio]',
      shippingMethodBox: '[data-shipping-method]',
      storeLocator: "[data-js-component='StoreLocatorComponent']",
      cartAlertBox: '[data-notification]',
      cartAlert: '.js-cart-alert',
      storeLocatorErrorMessage: '[data-select-store-error]',
      storeRadio: '[data-cart-store]',
    }
  }

  get CLASSES() {
    return {
      checked: 'checked',
      active: 'active',
      inactive: 'inactive',
      lastItem: 'remove-last',
      disabled: 'disabled',
      show: 'show',
      hidden: 'hidden',
      error: 'error',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.y = 0;
    this.quantityBoxes = this.$component.querySelectorAll(this.SELECTORS.qtyBtn);
    this.shippingRadios = this.$component.querySelectorAll(this.SELECTORS.shippingRadios);
    this.storeLocator = this.$component.querySelector(this.SELECTORS.storeLocator);
    this.cartAlert = this.$component.querySelector(this.SELECTORS.cartAlert);
    this.cartAlertBox = this.$component.querySelector(this.SELECTORS.cartAlertBox);
    this.storeLocatorErrorMessage = this.$component.querySelector(this.SELECTORS.storeLocatorErrorMessage);
    this.shippingMethodBoxes = this.$component.querySelectorAll(this.SELECTORS.shippingMethodBox);
  }

  quantityManager() {
    // update url
    let updateQtyUrl = document.querySelector(this.SELECTORS.cart).getAttribute('data-update-qty-url');
    // quantity box looop
    this.quantityBoxes.forEach(quantityBox => {
      let addBtn = quantityBox.querySelector(this.SELECTORS.more);
      let removeBtn = quantityBox.querySelector(this.SELECTORS.less);
      //
      addBtn.addEventListener('click', () => {
        if (!addBtn.classList.contains(this.CLASSES.disabled) && !addBtn.classList.contains(this.CLASSES.inactive)) {
          //disable button to prevent multiple clicks
          addBtn.classList.add(this.CLASSES.inactive);
          // set attribute data
          quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'),10) + 1);
          // go update quantity
          location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
        }
      });
      //
      removeBtn.addEventListener('click', (e) => {
        // btn to target , take care i click on the span
        let btn = (e.target.localName === 'i') ? e.target.parentNode : e.target ;
        if ( parseInt(quantityBox.getAttribute('data-qty'),10) > 0  && !btn.classList.contains(this.CLASSES.lastItem) && !btn.classList.contains(this.CLASSES.inactive)) {          // set attribute data
          //disable button to prevent multiple clicks
          btn.classList.add(this.CLASSES.inactive);
          quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'),10) - 1);
          // go update quantity
          location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
        }
      });
    });
  }

  handleShippingRadioClick() {
    if(this.shippingRadios) {
      this.shippingRadios.forEach(radio => {
        radio.addEventListener("click", event => {
          this.shippingMethodBoxes.forEach(box => {
            box.classList.remove(this.CLASSES.error);
          });
          if(this.storeLocator) {
            this.storeLocator.classList.remove(this.CLASSES.error);
            if(event.target.dataset.isClickAndCollect == 'true') {
              this.storeLocator.classList.remove(this.CLASSES.hidden);
            } else {
              //hide map section
              this.storeLocator.classList.add(this.CLASSES.hidden);
            }
          }
          //update shipping method
          this.submitAjaxCartForm(radio);
        });
      });
    }
  }

  handleStoreRadioClick() {
    // click collect select store
    this.$on( 'click', ({event})  => {
      this.submitAjaxCartForm(event.target);
    },'body',this.SELECTORS.storeRadio);
  }

  // ajax call to update delivery method
  submitAjaxCartForm(radio) {
    // remove error message in C&C section
    if(this.storeLocatorErrorMessage) {
      this.storeLocatorErrorMessage.classList.add("hidden");
    }
    const deliveryMethod = radio.value;
    let selectedStore = '';
    if (radio.getAttribute('data-cart-store')) {
      selectedStore = radio.getAttribute('id');
    }
    // go ajax
    fetch(
      `${document.location.href}?set-delivery-mode=updateDelivery&code=${deliveryMethod}&selectedStore=${selectedStore}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  bindEvents() {
    this.quantityManager();
    this.handleShippingRadioClick();
    this.handleStoreRadioClick();
    // cart alerts
    if (this.cartAlert !== null && this.cartAlertBox !== null) {
      this.cartAlertBox.classList.remove(this.CLASSES.hidden);
      setTimeout(() => {
        this.cartAlertBox.classList.add(this.CLASSES.hidden);
      }, 3000)
    }

    if (this.cartAlert !== null && this.cartAlertBox !== null) {
      this.cartAlertBox.height
      this.cartAlertBox.classList.remove(this.CLASSES.hidden);
      setTimeout(() => {
        this.cartAlertBox.classList.add(this.CLASSES.hidden);
      }, 3000)
    }
  }

  render() {
    this.bindEvents();
  }
}

